module.exports = __webpack_public_path__ + "static/media/7.b9b1a125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/7.jpg
// module id = 94
// module chunks = 0